import { MailOutlined } from '@ant-design/icons';
import { Flex, Form, Input } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Subtitle } from 'components/mvp-typography';
import { PrintableRootPage } from 'components/page/page-2';
import authSlice, {
  initialState,
  sendPasswordReset
} from 'features/auth/authSlice';
import { useReducer } from 'lib/hooks/useReducer';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { paths } from 'routes';
import { ConcussionRXLogo } from './concussionRx-logo';
import { ErrorMessage } from './ErrorMessage';
import { LinkTextComponent } from './page-sign-in';
import { styles } from './styles';

export function ForgotPassword() {
  const [{ error }, dispatch] = useReducer(authSlice, initialState); // user, isLoading,
  const [isLoading, setIsLoading] = useState(false);
  const onFinish = (values: { email: string }) => {
    setIsLoading(true);
    dispatch(sendPasswordReset(values.email));
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  return (
    <PrintableRootPage>
      <Flex justify="center" align="center" flex={1}>
        <Form
          onFinish={onFinish}
          name="forgot-password"
          className="login-form"
          style={styles.form}
          labelWrap={true}
        >
          <Flex vertical gap={16}>
            <Flex style={styles.titleContainer} justify="center">
              <ConcussionRXLogo />
            </Flex>
            <Flex vertical>
              <Subtitle>Reset your password</Subtitle>
              <ol>
                <li>Enter your account email.</li>
                <li>Click the reset link.</li>
                <li>Find the password reset email from ConcussionRx.</li>
                <li>Open the link in the email and follow the instructions.</li>
              </ol>
            </Flex>

            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter your email'
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email'
                }
              ]}
            >
              <Input
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="Email"
              />
            </Form.Item>

            <Form.Item>
              <Flex justify={'center'} align={'center'}>
                {error && <ErrorMessage errorMessage={error.message} />}
                <BaseButton
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={isLoading}
                >
                  Reset
                </BaseButton>
              </Flex>
            </Form.Item>
            <Flex
              style={{ float: 'left', textAlign: 'center', height: '27px' }}
              gap={8}
            >
              <span>Already have an account?</span>

              <Link
                to={{
                  pathname: paths.signIn()
                }}
                component={LinkTextComponent}
              >
                Login
              </Link>
            </Flex>
          </Flex>
        </Form>
      </Flex>
    </PrintableRootPage>
  );
}
